import { Component, HostListener, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { BaseComponent } from '@shared/components/base.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-new-calculator-dialog',
  templateUrl: './new-calculator-dialog.component.html',
  styleUrls: ['./new-calculator-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, AsyncPipe, TranslatePipe]
})
export class NewCalculatorDialogComponent extends BaseComponent implements OnInit {
  constructor(private readonly injector: Injector, public dialogRef: MatDialogRef<NewCalculatorDialogComponent>) {
    super(injector);
    dialogRef.disableClose = true;
  }

  @HostListener('window: keyup.esc') onKeyUp() {
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  closeAndContinue(): void {
    this.dialogRef.close();
  }
}
